"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTermsAndConditionsCookie = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _constants = require("../constants");
const getTermsAndConditionsCookie = () => Number(_jsCookie.default.get(_constants.termsAndConditionsCookieName));
exports.getTermsAndConditionsCookie = getTermsAndConditionsCookie;
